"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSigmaModelDefinition = void 0;
const zod_1 = require("zod");
const hil_sigma_model_definition_parameter_entry_js_1 = require("./hil-sigma-model-definition-parameter-entry.js");
const hil_sigma_model_signal_js_1 = require("./hil-sigma-model-signal.js");
const hil_repeatable_block_definition_js_1 = require("./hil-repeatable-block-definition.js");
const hilSigmaModelDefinitionSchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    parameters: hil_sigma_model_definition_parameter_entry_js_1.HilSigmaModelDefinitionParameterEntry.schema.array(),
    signals: hil_sigma_model_signal_js_1.HilSigmaModelSignal.schema.array(),
    repeatableBlocks: hil_repeatable_block_definition_js_1.HilRepeatableBlockDefinition.schema.array(),
});
exports.HilSigmaModelDefinition = {
    create(input) {
        return hilSigmaModelDefinitionSchema.parse(input);
    },
    schema: hilSigmaModelDefinitionSchema,
};
//# sourceMappingURL=hil-sigma-model-definition.js.map